import React, { FC, ReactElement } from 'react'
import { PartitionModal } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { isStringNotEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { StatusOutput } from '../../Common/Components/StatusOutput/StatusOutput'

type Props = {
    viewOnly?: boolean
    /** Localised display for configuration synchronisation last started (server-formatted). */
    telSysConfigSyncStartedAt?: Nullable<string>
    /** Localised display for last synchronisation status / error (server-formatted). */
    telSysConfigSyncLastError?: Nullable<string>
}

/**
 * Communication status tab: partition comms summary and configuration synchronisation status (read-only),
 * using the same building blocks as the TelSys configuration modal (disabled inputs + {@link StatusOutput}).
 *
 * @param props - Tab props.
 * @returns Communication status tab content.
 */
export const PartitionCommunicationStatusTab: FC<Props> = ({
    viewOnly,
    telSysConfigSyncStartedAt,
    telSysConfigSyncLastError
}: Props): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    const syncStartedPrefix: string = language.get(PartitionModal.PartitionModal_CommStatus_SyncLastStarted)
    const syncStartedDisplay: string = isStringNotEmpty(telSysConfigSyncStartedAt)
        ? `${syncStartedPrefix} ${telSysConfigSyncStartedAt}`
        : language.get(PartitionModal.PartitionModal_CommStatus_SyncLastStarted_Placeholder)
    const syncErrorDisplay: string = isStringNotEmpty(telSysConfigSyncLastError)
        ? telSysConfigSyncLastError
        : language.get(PartitionModal.PartitionModal_CommStatus_SyncLastError_Placeholder)

    return (
        <div
            className='partition-config-tab partition-config-tab--comm-status sync-tab tab-area'
            aria-readonly={viewOnly === true}
        >
            <h2 className='partition-config-tab__sync-status-title'>
                {language.get(PartitionModal.PartitionModal_CommStatus_SyncStatusTitle)}
            </h2>
            <StatusOutput statuses={[syncStartedDisplay, syncErrorDisplay]} />
        </div>
    )
}
